<script lang="ts">
  import SectionCheckProcessingList from '@/generated/sections/SectionCheckProcessingList.vue';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import Transaction from '@/extend/classes/Transaction';
  import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
  import { defineComponent } from "vue";

  export default defineComponent({
    components: {},
    extends: SectionCheckProcessingList,
    computed: {
      headers () {
        return [
          { text: "Date", value: 'dateTransaction', cellClass: '', sortable: true },
          { text: "Destinataire", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },
      canAdd (): boolean {
        return false;
      }
    },
    methods: {
      canUpdate (transaction: Transaction): boolean {
        return false;
      },
      defaultFilter (): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.CHEQUE_EMIS;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "statut";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionStatuts.PROCESSING;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      mdiAction (transaction: Transaction): string {
        return 'fas fa-print';
      },
      hasAction (transaction: Transaction): boolean {
        return true;
      },
      execAction (transaction: Transaction): void {
        this.actionProgress = true;
        Transaction.printCheck(transaction).then((res) => {
          transaction.bankId = res.bankId;
          this.actionProgress = false;
        }).catch(() => {
          this.actionProgress = false;
        });
      }
    }
  })

</script>
